import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaUser, FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated, currentUser } = useAuth();
  const { cartItemsCount } = useCart();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="nav">
      <div className="container nav-container">
        <div style={{display: 'flex', alignItems: 'center'}}>
          <img src="/app-logo.png" alt="app logo" style={{ height: '42px', width: '42px', marginRight: '8px' }} />
          <Link style={{textDecoration : 'none'}} to="/" className="nav-logo">
            Telering Process Pvt. Ltd
          </Link>
        </div>

        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul style={{marginBottom: 0, gap: '1rem'}} className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/products" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Products
            </Link>
          </li>
          <li>
            <Link to="/categories" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Categories
            </Link>
          </li>
          <li>
            <Link to="/bulk-orders" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Bulk Orders
            </Link>
          </li>
          <li>
            <Link to="/about" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              About
            </Link>
          </li>
          <li>
            <Link to="/contact" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>

        <div className="flex items-center gap-4">
          <Link to="/cart" className="nav-link position-relative" style={{ position: 'relative', display: 'inline-block' }}>
            <FaShoppingCart size={24} />
            {cartItemsCount > 0 && (
              <span 
                style={{
                  position: 'absolute',
                  top: 2,
                  right: 2,
                  background: '#ef4444',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: '0.85rem',
                  borderRadius: '50%',
                  minWidth: 22,
                  height: 22,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 8px rgba(31,38,135,0.10)',
                  zIndex: 2,
                  border: '2px solid #fff',
                  padding: '0 6px',
                }}
              >
                {cartItemsCount}
              </span>
            )}
          </Link>
          {isAuthenticated ? (
            <Link to="/profile" className="nav-link">
              <FaUser />
            </Link>
          ) : (
            <Link to="/login" className="nav-link">
              Login
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 